import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CheckboxField } from '../../../forms/fields/checkbox';
import { ChecklistField } from '../../../forms/fields/checklist';
import { DateField } from '../../../forms/fields/date-field';
import { DatePickerField } from '../../../forms/fields/date-picker';
import { DateRangeField } from '../../../forms/fields/date-range';
import { DropdownField } from '../../../forms/fields/dropdown/dropdown-field.component';
import { EmailField } from '../../../forms/fields/email-field';
import { MoneyField } from '../../../forms/fields/money-field';
import { MultiselectField } from '../../../forms/fields/multiselect';
import { NumberField } from '../../../forms/fields/number-field';
import { OptionSwitchField } from '../../../forms/fields/option-switch';
import { PhoneField } from '../../../forms/fields/phone-field';
import { PostalCodeField } from '../../../forms/fields/postal-code-field';
import { RadioField } from '../../../forms/fields/radio';
import { SearchField } from '../../../forms/fields/search-field';
import { SsnField } from '../../../forms/fields/ssn-field';
import { SwitchField } from '../../../forms/fields/switch';
import { TimeField } from '../../../forms/fields/time-field';
import { TimeRangeField } from '../../../forms/fields/time-range-field';
import { SelectListField } from '../../../forms/list-fields/select-list';

export const fieldComponentsMap = {
  checkbox: CheckboxField,
  multiselect: MultiselectField,
  checklist: ChecklistField,
  selectlist: SelectListField,
  optionswitch: OptionSwitchField,
  dropdown: DropdownField,
  switch: SwitchField,
  text: SearchField,
  radio: RadioField,
  datePicker: DatePickerField,
  dateRange: DateRangeField,
  date: DateField,
  email: EmailField,
  money: MoneyField,
  phone: PhoneField,
  ssn: SsnField,
  postalCode: PostalCodeField,
  time: TimeField,
  timeRange: TimeRangeField,
  number: NumberField,
};

const fieldHasOptions = {
  multiselect: true,
  checklist: true,
  optionswitch: true,
  dropdown: true,
  selectlist: true,
  radio: true,
};

const extraProps = {
  radio: { labelPlacement: 'left', label: undefined },
  checklist: { labelPlacement: 'left', label: undefined },
  optionswitch: { label: undefined },
};

export const FieldFilterWithOptions = ({ type, fieldProps, label, options }) => {
  const Component = fieldComponentsMap[type];
  return (
    <Component {...fieldProps} label={label} {...extraProps[type]}>
      {options.map((data, idx) => {
        switch (type) {
          case 'radio':
            return (
              <Component.Radio key={`${data}-${idx}`} value={data}>
                {data}
              </Component.Radio>
            );
          case 'checklist':
            return (
              <Component.Option key={`${data}-${idx}`} name={data}>
                {data}
              </Component.Option>
            );

          default:
            return (
              <Component.Option key={data} value={data}>
                {data}
              </Component.Option>
            );
        }
      })}
    </Component>
  );
};

export const FilterMapComponent = ({ type, fieldProps, label, options }) => {
  const hasOptions = !!fieldHasOptions[type];
  const Component = fieldComponentsMap[type];

  return hasOptions ? (
    <section
      css={css`
        margin-bottom: ${theme.spacing(2)};
      `}
    >
      <FieldFilterWithOptions type={type} fieldProps={fieldProps} label={label} options={options} />
    </section>
  ) : (
    <section
      css={css`
        margin-bottom: ${theme.spacing(2)};
      `}
    >
      <Component {...fieldProps} label={label} />{' '}
    </section>
  );
};
